import { modulePath } from "./moduleConstant";

export const routeConstants = {
  HOME: "/",
  ABOUT_ME:`/${modulePath.ABOUT}`,
  SERVICE_LIST:`/${modulePath.SERVICE}`,
  PORTFOLIO_LIST:`/${modulePath.PORTFOLIO}`,
  CONTACT_US:`/${modulePath.CONTACT}`,
  PORTFOLIO_DETAIL: `/${modulePath.PORTFOLIO}/detail`,
  REWARD_CERTIFICATES: `/${modulePath.CERTIFICATES}`,
};
